import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { AbstractControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { LgdFormControlFactory, LgdTextComponent } from "@tylertech/lgd-reactive-forms";
export interface PromptDialogData
{
    readonly title: string;
    readonly message: string;
    readonly initialValue?: string;
    readonly okLabel?: string;
    readonly cancelLabel?: string;
}

@Component({
    selector: "prompt-dialog-component",
    templateUrl: "./prompt.tmpl.html",
    imports: [
        CdkScrollable,
        LayoutAlignDirective,
        LayoutDirective,
        LgdTextComponent,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        ReactiveFormsModule
    ]
})
export class PromptDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<PromptDialogComponent>>(MatDialogRef);
    private readonly data = inject<PromptDialogData>(MAT_DIALOG_DATA);

    readonly formGroup: FormGroup;

    comment: string;
    isProcessing: boolean;

    constructor()
    {
        this.formGroup = new FormGroup({
            value: LgdFormControlFactory.text(this.data.initialValue, true)
        });
    }

    protected get control(): AbstractControl<string> { return this.formGroup.get("value"); }

    get title(): string { return this.data.title; }
    get message(): string { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "OK"; }
    get cancelLabel(): string { return this.data.cancelLabel ?? "Cancel"; }

    close(): void
    {
        this.dialogRef.close(this.control.value);
    }

    cancel(): void
    {
        this.dialogRef.close();
    }
}
